module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "leading-139-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("The conversation stopped as soon as the woman they had come for arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("They watched Nicola Tanner’s car slow, stop, then reverse expertly into a parking space a few houses down from her own. They watched the woman get out and retrieve something from the boot. They held their breath as she locked the car with a remote and began walking towards her house; saw her lit for a second or two as she passed beneath a streetlamp.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Good, she’s got bags.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Why is that good?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She’s got her hands full. She’ll be distracted.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘OK.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Their whispered breaths were briefly visible, eyes on the woman as she stepped to avoid a slick of leaves on the pavement and hitched her shoulder bag a little higher.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘What do you think’s in the bags?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘How should I know?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘They look heavy.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Doesn’t matter.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("They moved out of the shadows and across the road as the woman turned on to her front path. Quickly, but not too quickly, trying to time it right; heads down and hooded, ready to turn and walk casually away should anyone come along. A dog walker, a nosy neighbour. Emerging from between cars, they were coming through the gate as the woman pushed in her door key and one of them was calling out her name as she bent to pick up her bags from the step.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("They had the water pistols out by the time she turned round.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She opened her mouth, but the words, the scream, were quickly silenced by the twin jets of bleach, and a few seconds after she staggered back, blinded, and fell into her house, they were on her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Inside.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("The water pistols were shoved back into pockets and the bags that had been dropped just over the threshold were kicked aside, so that the door could be shut. Folders and files spilled out on to the hall carpet, a bottle of orange juice, a notebook, pens. They stood and watched as the woman spluttered and kicked out at them, inching herself across the floor towards the foot of the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Where does she think she’s going?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She’s not going anywhere.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("The woman continued to kick and shuffle until she reached the bottom stair and tried to sit up. One hand was pressed across her face while the other clutched at the carpet. She moaned and thrashed, frantic as her eyes and mouth burned, and the scream that resurfaced was strangled by the bleach that had run down her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘She looks like a crab or something.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("She moved one hand from her face, gasping as she struggled to open one eye. She squinted and sobbed.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Can she even see us?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Doesn’t matter, does it?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Seriously though, you reckon she can?’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("The woman froze when the knife was produced, as one of them moved to kneel down next to her.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Yeah, just about,’ he said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dcd61b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR02456.vue
// module id = 81
// module chunks = 0